import { ref } from 'vue';
import { useAxios } from '@/plugins/axios';

export const useArloService = () => {
    const axios = useAxios();
    const data = ref(null)
    const getDados = async (url) => {
        const response = await axios.get(url)
        data.value = response.data
        return data
    }

    return { getDados }
}
